export default {
    bart: [
        [1, 1],
        [0, 0],
        [0, 0],
        [2, 0],
        [1, 1],
        [2, 0],
        [4, 0],
        [1, 1],
        [0, 3],
        [0, 2],
        [0, 4],
        [0, 2],
        [1, 0],
        [0, 0],
    ],
    ricardo: [
        [2, 0],
        [3, 1],
        [2, 1],
        [0, 2],
        [3, 1],
        [2, 0],
        [0, 0],
        [4, 1],
        [2, 0],
        [1, 2],
        [0, 2],
        [1, 2],
        [0, 4],
        [1, 0],
    ],
    nico: [
        [0, 4],
        [1, 0],
        [3, 0],
        [0, 2],
        [3, 0],
        [2, 0],
        [2, 0],
        [1, 2],
        [1, 0],
        [0, 2],
        [2, 0],
        [0, 1],
        [2, 0],
        [0, 4],
    ],
    jeffrey: [
        [1, 1],
        [4, 3],
        [2, 2],
        [0, 2],
        [2, 2],
        [1, 2],
        [1, 3],
        [0, 1],
        [2, 0],
        [1, 2],
        [2, 0],
        [1, 0],
        [2, 0],
        [1, 0],
    ],
    maarten: [
        [2, 4],
        [0, 3],
        [2, 2],
        [0, 2],
        [2, 2],
        [1, 0],
        [0, 0],
        [2, 1],
        [3, 3],
        [1, 2],
        [2, 1],
        [1, 0],
        [3, 0],
        [2, 0],
    ],
    martijn: [
        [1, 1],
        [1, 1],
        [0, 3],
        [2, 0],
        [3, 0],
        [2, 1],
        [0, 1],
        [2, 2],
        [3, 2],
        [0, 2],
        [1, 0],
        [1, 0],
        [0, 3],
        [0, 3],
    ],
    koen: [
        [4, 0],
        [0, 2],
        [0, 3],
        [3, 0],
        [1, 4],
        [0, 2],
        [1, 0],
        [0, 3],
        [0, 0],
        [4, 0],
        [0, 2],
        [2, 0],
        [1, 2],
        [1, 0],
    ],
    jonathan: [
        [0, 3],
        [1, 0],
        [1, 1],
        [0, 2],
        [4, 0],
        [0, 2],
        [0, 0],
        [0, 4],
        [3, 3],
        [0, 2],
        [1, 2],
        [1, 0],
        [0, 3],
        [1, 0],
    ],
    patrick: [
        [1, 1],
        [0, 0],
        [2, 1],
        [0, 2],
        [4, 0],
        [0, 2],
        [0, 0],
        [0, 1],
        [2, 2],
        [0, 2],
        [0, 4],
        [1, 0],
        [1, 0],
        [1, 0],
    ],
    dennis: [
        [0, 1],
        [0, 0],
        [4, 0],
        [0, 2],
        [4, 3],
        [3, 0],
        [2, 3],
        [1, 2],
        [1, 2],
        [2, 0],
        [0, 2],
        [0, 4],
        [0, 2],
        [1, 0],
    ],
    jimmy: [
        [1, 1],
        [0, 2],
        [0, 3],
        [1, 2],
        [3, 0],
        [1, 2],
        [0, 2],
        [0, 1],
        [2, 1],
        [0, 2],
        [0, 3],
        [1, 0],
        [1, 0],
        [0, 4],
    ],
    franklin: [
        [2, 0],
        [0, 1],
        [4, 0],
        [2, 0],
        [2, 2],
        [2, 0],
        [0, 0],
        [1, 0],
        [2, 0],
        [0, 2],
        [0, 2],
        [0, 3],
        [4, 0],
        [1, 0],
    ],
};
